import { Component } from '@angular/core';

@Component({
  selector: 'lomas-admin-settings-page',
  template: '<h3>Settings</h3>'
})
export class AdminSettingsComponent {}
